import {
  AnnouncementEventType,
  AnnouncementListResponse
} from "../entities/announcements/Announcement";
import { isFeatureEnabled } from "../utils/featureFlags";
import RequestService from "./RequestService";

export * from "../entities/announcements/Announcement";

// Endpoints propuestos; confirmar con backend ([BE] Comunicados vigentes / Estado de lectura / Métricas).
// TODO(GDC-5174): integrar backend. Cuando los endpoints estén listos, borrar
// AnnouncementServiceMock, isMockEnabled y el flag "announcements" de featureFlags.
// Hoy el flag solo está prendido en local/dev, y ahí se usan siempre los datos de prueba.
const isMockEnabled = () => isFeatureEnabled("announcements");

// Import dinámico: el mock y su imagen quedan en un chunk aparte que producción no descarga.
const getMock = () =>
  import("./AnnouncementServiceMock").then((m) => m.AnnouncementServiceMock);

class AnnouncementService {
  /** Comunicados vigentes para el usuario, con su estado de lectura. */
  public static getList(): Promise<AnnouncementListResponse | Error> {
    if (isMockEnabled()) {
      return getMock().then((mock) => mock.getList());
    }
    return RequestService.post("/announcement/getlist", {});
  }

  public static markRead(announcementId: number): Promise<{} | Error> {
    if (isMockEnabled()) {
      return getMock().then((mock) => mock.markRead(announcementId));
    }
    return RequestService.post("/announcement/markread", { announcementId });
  }

  /**
   * "No volver a mostrar": el backend deja de devolverlo en getlist y lo cuenta como
   * descarte para las métricas del backoffice (GDC-5186). Implica leído.
   */
  public static dismiss(announcementId: number): Promise<{} | Error> {
    if (isMockEnabled()) {
      return getMock().then((mock) => mock.dismiss(announcementId));
    }
    return RequestService.post("/announcement/dismiss", { announcementId });
  }

  /** Métricas del backoffice: vistas, CTR y % descarte (GDC-5186). */
  public static track(
    announcementId: number,
    eventType: AnnouncementEventType
  ): Promise<{} | Error> {
    if (isMockEnabled()) {
      return getMock().then((mock) => mock.track(announcementId, eventType));
    }
    return RequestService.post("/announcement/track", {
      announcementId,
      eventType
    });
  }
}

export default AnnouncementService;
